<template>
  <div
    class="item-repeatable-loan-task item-row-alignment-justify-content"
    @click="openLoan">
    <div class="item-row-alignment-center">
      <weex-image
        v-if="imageIcon"
        :src="imageIcon"
        style="height: 38px;width: 38px; margin: 5px"
        :aria-hidden="true"></weex-image>

      <weex-text class="item-task-title">{{getTaskTitle}}</weex-text>
    </div>

    <weex-text class="item-update-text font-size-base item-align-right">Update</weex-text>
  </div>
</template>

<script>
  import { Activities } from "@/utils/ActivityNavigator";
  import EzUtils from "@/utils/EzUtils";
  import {Constants} from "@/components/Constants";
  import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

  export default {
    name: "PendingLoanTaskItem",
    props: {
      LoanTask: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    methods: {
      openLoan() {
        this.$emit('openTask', this.LoanTask)
      }
    },

    computed: {
      getTaskTitle() {
        const taskName = this.LoanTask && this.LoanTask.name ? this.LoanTask.name : "";
        if (!taskName) {
          return "";
        }
        let taskTitle;
        const activityDescription = Activities.getActivityDescription(taskName);
        if (taskName === Activities.KYC_RETAILER && EzUtils.areEqualString(Constants.FORM_60,
            LoanScopeDataHolder.getLoanCreationIdentifier(), true)
        ) {
          taskTitle = "Documents for Form-60";
        } else if (activityDescription && activityDescription.title) {
          taskTitle = activityDescription.title;
        }

        return taskTitle ? taskTitle : EzUtils.removeUnderscoreFromString(taskName);
      },

      imageIcon() {
        let imageSrc = '';
        if (Activities.getActivityDescription(this.LoanTask.name)
          && Activities.getActivityDescription(this.LoanTask.name).image) {
          imageSrc = Activities.getActivityDescription(this.LoanTask.name).image;
        }
        return imageSrc;
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .item-repeatable-loan-task {
    background-color: #CAC9C9;
    border-width: 1px;
    border-style: solid;
    border-color: #0F8DE8;
  }

  .item-update-text {
    padding: 10px 5px;
    font-weight: bold;
    color: #ffffff;
    background-color: #4D0000;
    margin-right: 5px;
  }
</style>
